import { initializeApp } from 'firebase/app';
import { getFirestore, enableMultiTabIndexedDbPersistence } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyAF0Mwy0yRDm6sABUbkrF4fNkzRslox7v4",
  authDomain: "gen-lang-client-0462953784.firebaseapp.com",
  projectId: "gen-lang-client-0462953784",
  storageBucket: "gen-lang-client-0462953784.firebasestorage.app",
  messagingSenderId: "590029704228",
  appId: "1:590029704228:web:d1e6b84e77f97c510a5cb1"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app, "ai-studio-santuwatch-ca54b6eb-1e27-4274-b75c-7566165cf892");

// Enable offline persistence
enableMultiTabIndexedDbPersistence(db).catch((err) => {
  if (err.code === 'failed-precondition') {
    // Multiple tabs open, persistence can only be enabled in one tab at a a time.
    console.warn('Firestore persistence failed: Multiple tabs open');
  } else if (err.code === 'unimplemented') {
    // The current browser doesn't support all of the features required to enable persistence
    console.warn('Firestore persistence failed: Browser not supported');
  }
});

const auth = getAuth(app);
const storage = getStorage(app);

export { db, auth, storage };
